import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'
import {IBadgeTemplate} from './getBadge'

export const getBadges = async (category?: string): Promise<ApiRes<IBadgeTemplate[]>> => {
    const query = category ? `?category=${category}` : ''
    return await apiGet(API_URL, `admin/badges${query}`)
}
